import { animate, animateChild, query, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import * as Bowser from 'bowser';
import { AppConfig } from '../../../core/services/app-config.service';
import { HandsetService } from '../../../core/services/handset.service';
import { VersionCheckService } from '../../../core/services/version-check.service';

@Component({
standalone: false,
  animations: [
    trigger('rollout', [
      state('void', style({ paddingTop: 0, paddingBottom: 0, height: 0, borderRadius: '8px' })),
      state('*', style({})),
      transition('void <=> *', [animate('300ms ease-out'), query('@quickfade', [animateChild()])]),
    ]),
    trigger('quickfade', [transition('void <=> *', [style({ opacity: 0 }), animate('200ms ease-out')])]),
  ],
  selector: 'app-auth',
  styleUrls: ['./auth.component.scss'],
  templateUrl: './auth.component.html',
})
export class AuthComponent {
  public browser = this.getBrowserName();

  constructor(
    public handsetService: HandsetService,
    public config: AppConfig,
    public versionCheck: VersionCheckService,
  ) {}

  public getBrowserName(): string {
    return Bowser.getParser(window.navigator.userAgent).getBrowserName();
  }
}
